import { Outlet } from "react-router";
import NavBar from "../components/common/NavBar";

function NavBarLayout() {
  return (
    <div>
      <NavBar />
      <Outlet />
    </div>
  );
}

export default NavBarLayout;
